import { Component } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { GlobalModalService } from 'src/app/core/services/global-modal.service';
import { AutoFocusDirective } from '../../directives/auto-focus.directive';
import { ModalOptions } from './modal-options';
import { ModalType } from './modal-type';

@Component({
  selector: 'th-global-modal',
  templateUrl: './global-modal.component.html',
  styleUrls: ['./global-modal.component.scss'],
  imports: [AutoFocusDirective]
})
export class GlobalModalComponent {
  constructor(private globalModalService: GlobalModalService) {}

  confirm() {
    this.modal.close();
  }

  confirmSecondary() {
    this.modal.close('secondary');
  }

  cancel() {
    this.modal.dismiss();
  }

  get modal(): NgbModalRef {
    return this.globalModalService.modal;
  }

  get options(): ModalOptions {
    return this.globalModalService.options;
  }

  get isConfirmModal(): boolean {
    return this.options.modalType === ModalType.CONFIRM;
  }

  get isConfirmSecondaryModal(): boolean {
    return this.options.modalType === ModalType.CONFIRM_SECONDARY;
  }
}
